import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export default class Image extends Component {
    getClasses() {
        return this.props.isSingle ? 'title-block' : 'card-title';
    }

    render() {
        console.log(this.props);
        if (this.props.src) {
	        return ( <img className="alignright pop-image" src={this.props.src} width={this.props.width} height={this.props.height} /> )
        } else {
	        return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/main/article/image.js